import { Component, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { BaseComponent } from '@varsity/components';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, AccountService, PlatformService,
    TempPassObject, ValidationService, TicketsService,
    DeviceInfo, InstituteSearchResult, EventTicketsResponse, EventsService
} from "@varsity/services";
import { ViewController, ToastController, NavParams, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'stadium-section-map',
    templateUrl: 'stadium-section-map.html'
})
export class StadiumSectionMapComponent extends BaseComponent {
    @Input() stadiumLayout: EventTicketsResponse;
    @Input() selectedSectionDetails: { level: string, section: string, priceRating: string };
    @Input() packageDetails?: { hasPackages: boolean, seasonPassId: string, sponsorID: number };

    instituteInfo: Promise<InstituteSearchResult> | null;
    eventID: number;
    sponsorID: number;
    promoCode: string;
    sectionLayout: any = null;
    viewer: any;
    device: string;

    @ViewChild('script') script: ElementRef;

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected accountService: AccountService,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected platformService: PlatformService,
        protected popoverCtrl: PopoverController,
        protected navParams: NavParams,
        protected validationService: ValidationService,
        protected iab: InAppBrowser,
        protected ticketsService: TicketsService,
        protected sanitizer: DomSanitizer,
        protected eventsService: EventsService,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "StadiumSectionMapComponent"
        );
    }

    ngOnInit() {
        this.eventID = parseInt(this.navParams.get("eventID"));
        this.sponsorID = this.packageDetails.hasPackages ? this.packageDetails.sponsorID : parseInt(this.navParams.get("sponsorID"));
        this.promoCode = this.navParams.get("promoCode") || "";
        this.device = this.platformService.platformDevice;

        this.instituteInfo = new Promise<InstituteSearchResult>((resolve, reject) => {
            if (this.navParams.get("instituteInfo")) {
                resolve(this.navParams.get("instituteInfo"));
            } else {
                this.tokenService.ensureValidToken().then((token) => {
                    this.eventsService.getInstitutionInfo(this.sponsorID)
                        .takeUntil(this.componentDestroyed$)
                        .subscribe(value => {
                            resolve(value);
                        }, (error) => {
                            this.handleError(error);
                            reject(error);
                        });
                });
            }
        });


    }

    ngAfterViewInit() {
        this.getSectionMap();
    }

    getSectionMap() {
        let { level, section, priceRating } = this.selectedSectionDetails;
        this.instituteInfo.then((sponsor) => {
            this.tokenService.ensureValidToken()
                .then(token => {
                    let sectionsWithPrices = this.stadiumLayout.sections.filter(p => p.Level == level &&
                        p.SectionName.replace(' ', '_') == section.replace(' ', '_'));

                    // look for the priceRating and pick the first one with this priceRating
                    sectionsWithPrices = sectionsWithPrices.filter(p => p.filterPrices && p.filterPrices.filter(x => x.PriceRating === priceRating).length > 0)

                    let filterPrices;
                    if (sectionsWithPrices && sectionsWithPrices.length > 0) {
                        filterPrices = sectionsWithPrices[0].filterPrices;
                    }

                    let sectionLayoutObervable;
                    if (this.packageDetails.hasPackages) {
                        sectionLayoutObervable = this.ticketsService.getSectionSeason(this.packageDetails.sponsorID, this.packageDetails.seasonPassId, level, section, priceRating, 10, sponsor.DBName, this.promoCode);
                    } else {
                        sectionLayoutObervable = this.ticketsService.getSectionLayout(filterPrices, this.eventID, level, section, priceRating, sponsor.DBName, this.promoCode, false);
                    }

                    sectionLayoutObervable
                        .takeUntil(this.componentDestroyed$)
                        .subscribe((layout) => {
                            if (!layout.ResultFlag) {
                                this.showNotification(layout.ResultMessage || "This section has no available seats !", undefined, undefined, "warning");
                                // go to stadium layout
                                window.postMessage('unavailable-seats', "*");
                                return;
                            }

                            const sectionLayout = layout;
                            sectionLayout.SectionLayoutHtml = this.sanitizer.bypassSecurityTrustHtml(sectionLayout.SectionLayoutHtml as string);
                            sectionLayout.JScript = sectionLayout.JScript;

                            const sectionWidth = sectionLayout.Width;
                            const sectionHeight = sectionLayout.Height;

                            this.sectionLayout = sectionLayout;
                            this.sectionLayout.Level = level;
                            this.sectionLayout.Section = section;
                            this.sectionLayout.PriceRating = priceRating;
                            this.notificationsService.notifySectionLayoutAvailable(this.sectionLayout);

                            this.includeScripts([], [sectionLayout.JScript]);

                            // we do not need to add the tickets to the selected ones
                            //if (this.receiptObjects) {
                            //    this.selectedTickets = this.receiptObjects.Tickets.filter(t => t.Level === level && t.Section === section);
                            //}

                            setTimeout(() => {
                                const jq = (window as any).jQuery;
                                const L = (window as any).L;

                                jq("#sectionLayoutContainer a").click(function (event) {
                                    event.preventDefault();
                                });

                                let firstImg;
                                var onLoadFunc = () => {
                                    var $img = jq(firstImg);

                                    $img.css('max-width', '100%').css('max-height', Math.floor(window.innerHeight / 2) + "px");
                                    $img.removeAttr('width').removeAttr('height');

                                    // image is actually altered ... we need to translate the coordinates
                                    var naturalWidth = firstImg.naturalWidth;
                                    var naturalHeight = firstImg.naturalHeight;
                                    var device = this.device;

                                    this.viewer = $img.imgViewer2({
                                        zoomMax: 5, // their documentatio is broken, maxZoom is not valid
                                        onReady: function () {
                                            var map = this.map;

                                            map.doubleClickZoom.disable();
                                            map.zoomControl.remove();

                                            var ratioX = naturalWidth / sectionWidth;
                                            var ratioY = naturalHeight / sectionHeight;

                                            const drawnItems = new L.FeatureGroup();
                                            //const d1 = new Date().getTime();

                                            var drawImage;
                                            drawImage = function ($el) {
                                                var left = parseFloat($el.css('left').replace('px', ''));
                                                var top = parseFloat($el.css('top').replace('px', '')); // we need to process the coordinates
                                                //var onClick = $el.attr('onclick'); // we need to change the onclick to remove the return false;
                                                var id = $el.find('a').attr('id');

                                                var $img = $el.find('img');
                                                var src = $img.attr('src');
                                                var width = parseFloat($img.attr('width'));
                                                var height = parseFloat($img.attr('height'));

                                                //var imageBounds = [[10, 20], [40, 50]];
                                                var imageBounds = [
                                                    [
                                                        Math.floor((sectionHeight - top) * ratioY),
                                                        Math.floor(left * ratioX)
                                                    ],
                                                    [
                                                        Math.floor((sectionHeight - top - height) * ratioY),
                                                        Math.floor((left + width) * ratioX)
                                                    ]
                                                ];
                                                var img = L.imageOverlay(src, imageBounds, { interactive: true, className: `overlay-${id}` });
                                                if (id) {
                                                    // if it has a link
                                                    img.on('click', (ev) => {
                                                        // redo this element after node selection changes
                                                        jq('#' + id).click();
                                                        //img.remove();
                                                        //drawImage($el);
                                                        if (img._url.indexOf('avaiseat.gif') > 0) {
                                                            let path = img._url.substring(0, src.lastIndexOf('/'));
                                                            let newPath = path + '/selseat.gif';
                                                            img.setUrl(newPath);

                                                            //img.setUrl('../images/selseat.gif');
                                                        } else {
                                                            let path = img._url.substring(0, src.lastIndexOf('/'));
                                                            let newPath = path + '/avaiseat.gif';
                                                            img.setUrl(newPath);

                                                            //img.setUrl('../images/avaiseat.gif');
                                                        }
                                                        console.log('After: ' + img._url);
                                                    });
                                                }

                                                drawnItems.addLayer(img);
                                                return img;
                                            }
                                            let draggable = device === 'desktop' ? jq('.display-content').find('#draggable') : jq('#draggable');


                                            // hide all of these
                                            draggable.find('span[id^="Span"]').hide();

                                            // read the area for zoom3 and process those coordinates. we are displaying map level 3
                                            draggable.find('span[id^="Span"]').each(function (index, el) {
                                                var $el = jq(el);
                                                drawImage($el);
                                            });

                                            //const d2 = new Date().getTime();
                                            //console.log("Phase 1", d2 - d1);
                                            drawnItems.addTo(map);
                                            //const d3 = new Date().getTime();
                                            //console.log("Phase 2", d3 - d2);

                                            // avoid bouncing image
                                            this.setZoom(2);
                                            this.setZoom(1);
                                        },
                                        onClick: function (e, pos) {

                                        }
                                    });
                                }

                                firstImg = jq("#SectionLayoutHtml").find('img')[0];
                                if (firstImg.complete) {
                                    onLoadFunc();
                                } else {
                                    firstImg.onload = onLoadFunc;
                                }
                            }, 50);
                        });
                });
        });
    }

    includeScripts(scriptFiles: string[], scriptSources: string[]) {
        // add the scripts

        var element = this.script.nativeElement;

        // clear any other scripts
        while (element.children.length > 0) {
            element.children[0].remove();
        }

        for (let i = 0; i < scriptFiles.length; i++) {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = scriptFiles[i];;

            // add this script
            element.appendChild(script);
        }

        for (let i = 0; i < scriptSources.length; i++) {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.innerHTML = scriptSources[i];;

            // add this script
            element.appendChild(script);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/stadium-section-map/stadium-section-map.ts